/**
* 头部菜单
*/ 
<template>
  <el-menu class="el-menu-demo" mode="horizontal" background-color="#334157" text-color="#fff" active-text-color="#fff">
    <el-button class="buttonimg">
      <img class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)">
    </el-button>
    <el-submenu index="2" class="submenu">
      <template slot="title">
        <div style="display: flex;">
          <jazzicon :address="userAddress" :diameter="30" />
          <div style="margin-left: 10px;">{{ userAddress | plusXing2}}</div>
        </div>
      </template>
      <el-menu-item index="2-1">设置</el-menu-item>
      <el-menu-item @click="exit()" index="2-3">退出</el-menu-item>
    </el-submenu>
  </el-menu>
</template>
<script>
import { loginout } from '../api/userMG'
import Jazzicon from 'vue-jazzicon'
import { ethers } from 'ethers'
export default {
  name: 'navcon',
  components: {
    [Jazzicon.name]: Jazzicon
  },
  data() {
    return {
      collapsed: true,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      userAddress: {}
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    let _this = this;
    _this.Init((valAddress) => {
      _this.userAddress = localStorage.getItem('userAddress')
      console.log(_this.userAddress)
      console.log(valAddress)
      if(valAddress.toLowerCase() != _this.userAddress.toLowerCase()) {
        _this.$message({
          type: 'success',
          message: '已切换钱包，请重新授权登录!'
        })
        localStorage.clear()
        setTimeout(() => {
          _this.$store.commit('logout', 'false')
          _this.$router.push({ path: '/login' })  
        }, 1000)
      }
    });
  },
  filters: {
    plusXing2(str) {
				if (str.length == 0) {
					return "";
				}
				var len = str.length - 4;
				var xing = '';
				for (var i = 0; i < 5; i++) {
					xing += '*';
				}
				return str.substring(0, 6) + xing + str.substring(str.length - 4);
			}
  },
  methods: {
    // 退出登录
    exit() {
      // this.$router.push({ path: '/login' })
      // setTimeout(() => {
      //             this.$store.commit('logout', 'false')
      //             this.$router.push({ path: '/login' })
      //             this.$message({
      //               type: 'success',
      //               message: '已退出登录!'
      //             })
      //           }, 1000)
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          loginout()
            .then(res => {
              if (res.success) {
                setTimeout(() => {
                  this.$store.commit('logout', 'false')
                  this.$router.push({ path: '/login' })
                  localStorage.clear()
                  this.$message({
                    type: 'success',
                    message: '已退出登录!'
                  })
                }, 1000)
              } else {
                this.$message.error(res.msg)
                return false
              }
            })
            .catch(err => {
              this.$message.error('退出失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    async Init(callback) {
      if (typeof window.ethereum === "undefined") {
        console.log("请安装MetaMask")
      } else {
        let wert = new ethers.providers.Web3Provider(window.ethereum);
        const accounts = await wert.send("eth_requestAccounts", []);
        callback(accounts[0]);
      }
		},
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    }
  }
}
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu {
  float: right;
}
.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}
.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/navcon.vue